import { fetchWithAuthorization } from '../../../helpers/fetch-with-authorization';

export type UpdateEmailAddressFn = (payload: {
    request: {
        newEmailHandle: string;
        targetIdentityId: string;
    };
    accessToken: string;
}) => Promise<void>;

export function initUpdateEmailAddressFn({
    baseUrl,
}: {
    baseUrl: string;
}): UpdateEmailAddressFn {
    const href = 'identity-group/v1/identitygroups/change-handle';
    return async ({ request, accessToken }) => {
        const url = `${baseUrl}/${href}`;
        const response = await fetchWithAuthorization({
            url,
            method: 'PUT',
            accessToken,
            body: request,
        });
        if (!response.ok) return Promise.reject(await response.json());
        /**
         * NOTE:
         * We intentfully don't return response.json() here when response okay
         */
    };
}
